function navCurrent(){
    let winScr = $(window).scrollTop();
    let ttlId = ['#feature','#flow',/*'#case',*/'#support','#media'];
    let navLink = $('.abt-menu__item');
    for(let i=0;i<ttlId.length;i++){
        let ttlPos = $(ttlId[i]).position().top;
        if(ttlPos - 200 < winScr){
            navLink.removeClass('is-current');
            navLink.eq(i).addClass('is-current');
        } else if(winScr < $(ttlId[0]).position().top - 300) {
            navLink.removeClass('is-current');
        }
    }
    let docHeight = $(document).innerHeight(),
    windowHeight = $(window).innerHeight(), 
    pageBottom = docHeight - windowHeight; 
    if(pageBottom <= $(window).scrollTop()) {
        navLink.removeClass('is-current');
        navLink.eq(ttlId.length - 1).addClass('is-current');
    }    
}

$(window).on('scroll', function(){
    navCurrent()
});
